<template>
  <div
      style="width: 100%; height: 100%"
      class="d-flex justify-center align-center flex-column"
  >
    <v-card
        class="d-flex justify-center align-center flex-column px-16 pb-16"
    >
      <div
          class="d-flex align-center justify-center mb-3"
          style="border-radius: 1px"
      >
        <v-img
            :src="require('../assets/montezuma_purple.svg')"
            width="300"
        />
      </div>

      <div v-if="loading">
        <div class="d-flex justify-center my-4">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          />
        </div>

        <div class="text-h6 font-weight-medium mt-5">
          {{$t(translation + '.loadingData')}}
        </div>
      </div>
      <div v-else>
        <div v-if="message === ''">
          <v-alert
              type="error"
          >
            {{$t(translation + '.formDeletingAcc')}}
          </v-alert>
          <div class="mb-2 ">
            {{ $t(this.translation + '.insertData') }}
          </div>
          <v-form ref="form" class="ma-0 pa-0 mt-4" style="width: 100%">
            <v-text-field
                class="ma-0 pa-0"
                v-model="username"
                :label="$t(translation + '.username') + ' *'"
                :rules="usernameRules"
                autocomplete="off"
                outlined
                dense
            />
            <v-text-field
                class="ma-0 pa-0"
                v-model="email"
                :label="$t(translation + '.email') + ' *'"
                :rules="emailRules"
                autocomplete="off"
                outlined
                dense
            />
            <div
                class="mb-2"
                style="width: 100%"
            >
              <div
                  class="caption mt-1"
              >{{ $t('general.validationMsg') }}</div>
            </div>
            <v-btn
                color="primary"
                block
                :loading="loadingSubmit"
                @click="requestDelete()"
            >
              {{ $t(translation + '.confirm') }}
            </v-btn>
          </v-form>
        </div>
        <div v-else>
          <div
              class="d-flex justify-center"
          >
            <v-icon
                class="my-3"
                size="120"
                :color="iconColor"
            >
              {{icon}}
            </v-icon>
          </div>

          <div
              class="text-h6 font-weight-medium mt-5"
          >
            {{message}}
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import {showSwalPopUpConfirmation} from "../utils/functions"
import axios from "axios"
export default {
  name: "DeleteAccount",
  data() {
    return {
      translation: "delete_account",
      username: '',
      email: '',
      loading: false,
      loadingSubmit: false,
      message: '',
      icon: '',
      iconColor: '',
      usernameRules: [
          v => !!v || this.$t(this.translation + '.username_required')
      ],
      emailRules: [
          v => !!v || this.$t(this.translation + '.email_required'),
          v => /.+@.+\..+/.test(v) || this.$t(this.translation + '.email_valid')
      ]
    }
  },
  methods: {
    ...mapMutations("snackbar", {
      setSnackbar: "setSnackbar"
    }),
    showSwalPopUpConfirmation,
    resetForm() {
      this.email = ""
      this.username = ""
    },
    async requestDelete() {
      if(!this.$refs.form.validate()){
        return
      }
      const response = await this.showSwalPopUpConfirmation(this.$t(this.translation + ".confirm_delete_message"), "info")
      if (response.isConfirmed) {
        this.loadingSubmit = true
        axios.post("/api/delete-account", {
          username: this.username,
          email: this.email
        }).then((response) => {
          if(response.data && response.data.message) {
            this.icon = "mdi-check-circle-outline"
            this.iconColor = "success"
            this.message = response.data.message
          }
          this.resetForm()
        }).catch((error) => {
          if (error.response && error.response.data) {
            this.setSnackbar({color: "red", text: error.response.data.message})
          }
        }).finally(() => {
          this.loadingSubmit = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>